import ErrorIcon from "@material-ui/icons/Error";
import React from "react";
import { tesaDarkRedError } from "../../styles/colors";

const CustomErrorIcon: React.FC = () => (
  <ErrorIcon className="muiErrorIcon" style={{ color: tesaDarkRedError, marginRight: "1rem" }} />
);

export default CustomErrorIcon;
